// extracted by mini-css-extract-plugin
module.exports = {"List":"Games_List__2UMaQ"};